// jQuery + plugins, replacing the old hand-vendored Sprockets copies in
// app/assets/javascripts/libs/. Split into its own pack (rather than living
// in application.js) because application.js is also loaded by admin.html.erb,
// which has its own separate jQuery (bundled via the jquery-rails gem) and
// never used these plugins -- keeping this pack out of admin.js avoids both
// shipping unused code there and clobbering admin's window.jQuery.
//
// Referenced from application.html.erb with `defer: false`: this must run
// synchronously, in place, before the Sprockets application.js bundle
// (main.js/uploads.js), which references the bare `$`/`jQuery` globals at
// parse time. javascript_pack_tag defaults to defer: true, which would
// otherwise run this after the document finishes parsing -- i.e. after
// Sprockets' non-deferred bundle already ran.
const $ = require('jquery');
window.$ = window.jQuery = $;

// jquery-ui's widget.js and fancyBox aren't real UMD/CommonJS modules -- they
// read window.jQuery directly instead of require()-ing it, so window.jQuery
// must already be set above before requiring them. (Using require(), not
// import, throughout this block: Babel hoists all `import`s above plain
// statements, which would run these before window.jQuery was set.)
require('blueimp-file-upload/js/jquery.iframe-transport');
// jquery.fileupload.js declares its jquery-ui/widget dependency via an AMD
// define([...]) call. Webpack statically parses that UMD boilerplate and
// resolves it to the real `jquery-ui` package below (not fileupload's own
// bundled, older vendor copy of widget.js, which is never reached) -- so
// there's a single, package.json-pinned $.widget implementation, not two
// competing versions. Verified by inspecting the compiled bundle.
require('blueimp-file-upload/js/jquery.fileupload');
require('jquery-ui/ui/widget');
require('@fancyapps/fancybox');
require('jquery-textcomplete');
import '@fancyapps/fancybox/dist/jquery.fancybox.css';
